import ActionWidget from './actionWidget';
import Widget from './widget';
import React from 'react';
import $ from 'jquery';

const WidgetRenderer = (function () {
  function widgetsForObject(object, callback, property = 'widgetIds', defaultWidget = false) {
    const propertyMissing = !{}.hasOwnProperty.call(object, property);
    const items = object[property].filter((item) => item !== '');
    const propertyEmpty = !items.length;

    if (propertyMissing || propertyEmpty) { return null; }

    let params;

    switch (property) {
      case 'positions':
        params = `positions=${object[property]}`;
        break;
      default:
        params = `filter=${object[property]}`;
        break;
    }

    if (defaultWidget) {
      params += '&default=1';
    }

    $.ajax({
      url: `/api/v3/widgets.json?${params}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null && callback) {
          callback(data.widgets);
        }
      },
      error: (xhr, status, err) => console.error(xhr, status, err.toString())
    });

    return true;
  }

  function widgetsForPosition(widgets, position) {
    return widgets
      .filter(widget => widget.tag_list.indexOf(position) !== -1)
      .sort((widgetA, widgetB) => {
        let sortOrder = 1;

        if (widgetA.sorter && widgetB.sorter) {
          if (widgetA.sorter < widgetB.sorter) {
            sortOrder = -1;
          }
          if (widgetA.sorter === widgetB.sorter) {
            sortOrder = 0;
          }
        }

        return sortOrder;
      });
  }

  function renderWidgets(widgets, position) {
    return widgetsForPosition(widgets, position).map(widget =>
      <Widget
        content={widget.content}
        id={widget.id_name || `widget_id_${widget.id}`}
        className={widget.css_name}
        key={`widget_id_${widget.id}`}
      />
    );
  }

  function renderActionWidget(articleType, article) {
    let calendarImport = false,
        contactImport = false,
        bookmark = false;

    switch (articleType) {
      case 'branch':
        bookmark = true;
        break;
      case 'consultant':
        contactImport = true;
        bookmark = true;
        break;
      case 'event':
        calendarImport = true;
        break;
      default:
        break;
    }

    return (
      <ActionWidget
        calendarImport={calendarImport}
        contactImport={contactImport}
        bookmark={bookmark}
        articleId={article.id}
      />
    );
  }

  return {
    widgetsForObject,
    renderWidgets,
    renderActionWidget
  };
}());

export default WidgetRenderer;



// WEBPACK FOOTER //
// ./components/widgets/widgetRenderer.js